<template>
  <div
    style="background-color: #fff;overflow: hidden;min-height: calc(100vh - 82px)"
  >
    <div class="study-container">
      <h3 class="title">{{ title }}</h3>
      <div class="player-container">
        <div class="player-wrapper">
          <video-player
            v-show="playerOptions.sources[0].src"
            ref="video"
            :options="playerOptions"
            @loadeddata="onPlayerLoadeddata($event)"
            @ended="onPlayerEnded($event)"
          ></video-player>
        </div>
        <div class="lessons-wrapper">
          <p class="info-wrapper" style="font-size: 20px" v-if="type == 'demo'">
            伊索寓言教学示范课
          </p>
          <div class="info-wrapper" v-else>
            <img class="avatar" :src="face" alt="" />
            <div class="data-wrapper">
              <p class="info">
                <span class="name">{{ name }}</span
                ><span class="means">{{ means }}</span>
              </p>
              <p class="school" v-if="type != 'mingshi' && type !== 'subject'">
                任课学校：{{ school }}
              </p>
            </div>
          </div>
          <div class="dir-minshi" v-if="type == 'minshi'">
            {{ playCourse.titleCn }}
            <span>{{ playCourse.titleEn }}</span>
          </div>
          <div class="dir" v-else>课程目录</div>
          <div class="collection-container">
            <ul class="collection-wrapper">
              <li
                class="collection"
                :class="{ active: activeIndex == index }"
                v-for="(item, index) in lessons"
                :key="index"
                ref="collection"
                @click="selectLesson(index)"
              >
                <div class="item">
                  {{ item }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="profile-container" v-if="type !== 'mingshi' && type !== 'subject'">
        <h3 class="profile-title">教师简介</h3>
        <div class="profile-content">
          <div class="left">
            <img :src="face" alt="" />
            <p class="name">{{ name }}</p>
            <p class="means">{{ means }}</p>
            <p class="school">任课学校：{{ school }}</p>
          </div>
          <div class="right">
            <div class="desc" v-html="profile"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import API from "../api";
import "video.js/dist/lang/zh-CN";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";

Vue.use(videoPlayer);

export default {
  components: {
    videoPlayer
  },
  data() {
    return {
      playerOptions: {
        autoplay: true,
        fluid: true,
        playsinline: true,
        language: "zh-CN",
        // playbackRates: [0.7, 1.0, 1.5, 2.0],
        controlBar: {
          remainingTimeDisplay: false,  
          volumePanel: {
            inline: false,                
          }
        },
        sources: [
          {
            type: "video/mp4",
            src: ""
          }
        ]
      },
      type: "", //播放界面要播放的视频类型

      title: "", //标题
      means: "", //身份 + 教龄
      name: "", //姓名
      school: "", //学校
      face: "", //头像
      lessons: [], //课程分集列表
      profile: "", //个人简介
      activeIndex: 0, //当前播放的集数索引
      video: [],
      playCourse: {}, //民师课 当前播放的课程信息
      famousCourse: [], //名师课程
      showFamousCourse: [] //删去正在播放的课程卡片
    };
  },
  mounted() {
    let { title, means, name, school, type, face } = this.$route.query;
    this.title = decodeURIComponent(title);
    this.means = decodeURIComponent(means);
    this.name = decodeURIComponent(name);
    this.school = decodeURIComponent(school);
    this.face = decodeURIComponent(face);
    this.id = this.$route.params.id;
    this.userId = sessionStorage.getItem("userId");

    this.userData =
      localStorage.getItem(this.userId) &&
      JSON.parse(localStorage.getItem(this.userId));

    this.type = decodeURIComponent(type);
    this.getCourse();
  },
  computed: {
    player() {
      return this.$refs.video.player;
    }
  },
  methods: {
    getCourse() {
      axios.post(API.lessons, {
        subject_id: this.id
      }).then(res => {
        let { profile, name, face } = res.result; 
        this.lessons = name;
        this.face = face ? face : this.face;
        this.profile = profile;
        this.getVideo();
      })
    },
    getVideo(index) {
      axios.post(API.video, {
        subject_id: this.id,
        lesson: index ? index : 0
      }).then(res => {
        let { video } = res.result;
        this.playerOptions.sources[0].src = video;
        this.video[index ? index : 0] = video;
        this.playData = {
          activeIndex: index ? index : 0
        }
        this.recovery()
      })
    },
    
    //恢复播放
    recovery() {
      if (this.playData) {
        this.activeIndex = this.playData.activeIndex;
        this.playerOptions.sources[0].src = this.video[this.activeIndex];

        this.$nextTick(() => {
          this.$refs.collection[this.activeIndex] &&
            this.$refs.collection[this.activeIndex].scrollIntoView();
          setTimeout(() => {
            document.documentElement.scrollTop = 0;
          }, 0);
        });
      }
    },
    selectLesson(index) {
      this.activeIndex = index;
      this.getVideo(index);
    },
    //视频数据加载好
    onPlayerLoadeddata(player) {
      if (this.playData && this.playData.activeIndex == this.activeIndex) {
        player.currentTime(this.playData.time);
      }
      this.savePlayedTimer = setInterval(() => {
        let time = this.player.currentTime();
        let playData = { activeIndex: this.activeIndex, time: time };

        let id = this.type === "minshi" ? this.courseId : this.id;
        let userData = { [id]: playData };
        localStorage.setItem(this.userId, JSON.stringify(userData));
      }, 5000);
    },
    onPlayerEnded(player) {
      if (this.activeIndex < this.lessons.length - 1) {
        let newIndex = this.activeIndex + 1;
        this.activeIndex = newIndex;
        this.playerOptions.sources[0].src = this.lessons[newIndex].url;
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.savePlayedTimer);
  }
};
</script>

<style scoped lang="scss">
.study-container {
  width: 1200px;
  margin: 0 auto;
  .title {
    color: #3c3c3c;
    font-size: 22px;
    line-height: 1;
    margin-top: 37px;
  }
  .player-container {
    margin-top: 18px;
    width: 1200px;
    height: 467px;
    display: flex;
    .player-wrapper {
      display: inline-block;
      position: relative;
      z-index: 2;
      max-width: 100%;
      width: 830px;
      height: 100%;
      .video-player {
        max-width: 100%;
      }
    }
    .lessons-wrapper {
      width: 30.84%;
      height: 100%;
      background-color: #eff4f8;
      .info-wrapper {
        height: 92px;
        background-color: #dceef7;
        display: flex;
        align-items: center;
        // justify-content: center;
        box-sizing: border-box;
        padding-left: 20px;
        .avatar {
          width: 50px;
          height: 50px;
          background-color: #cacaca;
          object-fit: cover;
          border-radius: 50%;
          margin-right: 10px;
        }
        .data-wrapper {
          .info {
            color: #3c3c3c;
            font-size: 14px;
            display: flex;
            align-items: center;
            .name {
            }
            .means {
              margin-left: 10px;
              padding: 0 10px;
              border-radius: 14px;
              border: solid 1px rgba(56, 181, 239, 0.5);
              color: rgba(60, 60, 60, 0.5);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              max-width: 220px;
              display: inline-block;
            }
          }
          .school {
            line-height: 1;
            margin-top: 7px;
            font-size: 14px;
            color: rgba(60, 60, 60, 0.5);
          }
        }
      }
      .dir-minshi {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #38b5ef;
        font-size: 16px;
        font-weight: bold;
        height: 45px;
        line-height: 45px;
        padding-left: 20px;
        border-bottom: 1px solid #c3e9fa;
        span {
          font-size: 14px;
          font-weight: normal;
        }
      }
      .dir {
        font-size: 16px;
        color: #38b5ef;
        height: 45px;
        line-height: 45px;
        padding-left: 20px;
        border-bottom: 1px solid #c3e9fa;
      }
      .collection-container {
        height: 329px;
        overflow-y: auto;
        .collection-wrapper {
          .collection {
            color: #eff4f8;
            position: relative;
            cursor: pointer;
            &:first-child {
              &::before {
                content: "";
                position: absolute;
                width: 2px;
                height: 20px;
                left: 20px;
                background-color: currentColor;
                z-index: 10;
              }
            }
            &:last-child {
              &::before {
                content: "";
                position: absolute;
                width: 2px;
                height: 21px;
                left: 20px;
                background-color: currentColor;
                z-index: 10;
                bottom: 0;
              }
            }
            &:hover,
            &.active {
              color: #fff;
              background-color: #fff;
              .item {
                color: #38b5ef;
                &::before {
                  width: 12px;
                  height: 12px;
                  background-color: #38b5ef;
                  left: -7px;
                  top: 18px;
                }
              }
            }
            .item {
              height: 48px;
              line-height: 48px;
              font-size: 14px;
              margin-left: 20px;
              border-left: 2px dotted #99a4aa;
              padding-left: 13px;
              position: relative;
              color: #3c3c3c;
              &::before {
                content: "";
                position: absolute;
                width: 8px;
                height: 8px;
                background-color: #95989a;
                border-radius: 50%;
                top: 20px;
                left: -5px;
                z-index: 10;
              }
            }
          }
        }
      }
    }
  }
  .profile-container {
    margin-top: 24px;
    margin-bottom: 40px;
    border-radius: 6px;
    border: solid 2px rgba(56, 181, 239, 0.3);
    .profile-title {
      line-height: 44px;
      color: #3c3c3c;
      font-size: 16px;
      padding-left: 32px;
      border-bottom: 1px solid #c3e9fa;
    }
    .profile-content {
      padding: 22px 32px;
      display: flex;
      .left {
        img {
          width: 163px;
          height: 218px;
          object-fit: cover;
        }
        .name {
          color: #3c3c3c;
          font-size: 16px;
          line-height: 1.6;
          margin-top: 5px;
        }
        .means,
        .school {
          line-height: 1.7;
          font-size: 14px;
          color: rgba(60, 60, 60, 0.5);
        }
      }
      .right {
        margin-left: 29px;
        .desc-title {
          font-weight: bold;
          font-size: 16px;
          color: #3c3c3c;
        }
        .desc {
          font-size: 14px;
          color: #3c3c3c;
          // text-indent: 2em;
          text-align: justify;
          line-height: 26px;
        }
      }
    }
  }
  .famous-container {
    margin-top: 29px;
    margin-bottom: 40px;
    .famous-title {
      line-height: 38px;
      color: #3c3c3c;
      font-size: 16px;
      padding-left: 32px;
      border-bottom: 1px solid #c3e9fa;
    }
    .more-container {
      margin-right: -24px;
      .more-wrapper {
        display: flex;
        flex-wrap: wrap;
        .card {
          padding: 10px 9px;
          box-sizing: border-box;
          margin: 20px 20px 0 0;
          width: 286px;
          height: 267px;
          background-color: #ffffff;
          border-radius: 10px;
          border: solid 2px rgba(56, 181, 239, 0.3);
          transition: transform 0.3s;
          cursor: pointer;
          &:hover {
            transform: scale(1.05);
          }
          img {
            width: 264px;
            height: 168px;
            border-radius: 4px;
          }
          .info {
            margin-top: 10px;
            .top {
              display: flex;
              justify-content: space-between;
              .name {
                color: #3c3c3c;
                font-size: 18px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
              .total {
                color: #c3c3c9;
                font-size: 16px;
                white-space: nowrap;
              }
            }
            .desc {
              margin-top: 3px;
              color: #c3c3c9;
              font-size: 16px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.right {
  .desc {
    strong {
      font-weight: bold;
    }
  }
}
.video-js{
  font-size: 15px;
}
// 显示视频总时长
.video-js .vjs-time-control{
  display:block;
  padding: 0;
}
.video-js .vjs-time-divider{
  min-width: 1em;
  text-align: center;
}
.video-js .vjs-big-play-button{
  top: 50%;
  left: 50%;
  transform: translateX(-1.5em) translateY(-0.75em);
}
</style>
